import React, { createContext, useContext, useState, useCallback } from "react";

interface Notification {
  id: string;
  message: string;
}

interface NotificationContextType {
  notify: (message: string) => void;
}

const NotificationContext = createContext<NotificationContextType>({ notify: () => {} });

export function NotificationProvider({ children }: { children: React.ReactNode }) {
  const [notifications, setNotifications] = useState<Notification[]>([]);

  const notify = useCallback((message: string) => {
    const id = crypto.randomUUID();
    setNotifications(prev => [...prev, { id, message }]);
    setTimeout(() => {
      setNotifications(prev => prev.filter(n => n.id !== id));
    }, 5000);
  }, []);

  return (
    <NotificationContext.Provider value={{ notify }}>
      {children}
      <div style={{ position: "fixed", bottom: 24, right: 24, zIndex: 99999, display: "flex", flexDirection: "column", gap: 10 }}>
        {notifications.map(n => (
          <div key={n.id} style={{
            background: "#1e1e2e",
            border: "1px solid #ff4d4d",
            color: "#ff4d4d",
            padding: "12px 16px",
            borderRadius: 10,
            fontSize: 14,
            maxWidth: 360,
            boxShadow: "0 4px 12px rgba(0,0,0,0.3)"
          }} className="notification-toast">
            ❌ {n.message}
          </div>
        ))}
      </div>
    </NotificationContext.Provider>
  );
}

export function useNotification() {
  return useContext(NotificationContext);
}